import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { connect } from 'react-redux'
import {createStructuredSelector} from 'reselect'
import styled from 'styled-components'
import { blinkBuilder } from 'helpers'
import {vars} from '../common'
import Menu from '../Menu'
import selectors from 'widget/store/selectors'
import { RiSendPlaneLine } from 'react-icons/ri'
import { isMobile } from 'react-device-detect'
import TOCButton from '../TableOfContents/Button'
import { newUserMessage }from 'App/actions'
import { FaExpand, FaCompress } from 'react-icons/fa'
import { FULLSCEEN_WIDTH_BREAKPOINT } from 'src/constants'


const TextInput = props => <Input {...props} type="text" />
const TextareaInput = props => <Textarea {...props} />
const DateInput = (props) => (
  <Input {...props} type="date" min="1900-01-01" max="2100-12-12" />
)

const Sender = ({
  placeholder,
  isFetching,
  inputDisabled,
  onMenuItemClick,
  dateInput,
  blink,
  blinkColor,
  newUserMessage,
  clearInput,
}) => {
  const [inputExpanded, setInputExpanded] = useState(false)
  const [value, setValue] = useState('')
  const btnDisabled = inputDisabled || isFetching
  const isInputExpanded = !dateInput && inputExpanded

  const handleMessageSubmit = (e) => {
    e.preventDefault()
    const userInput = e.target.message.value

    if (!userInput.trim()) return

    newUserMessage(userInput)
    setValue("")
  }
  useEffect(() => { 
    if (clearInput) setValue("")
  }, [clearInput])

  const inputProps = {
    name: "message",
    autoComplete: "off",
    autoFocus: !isMobile,
    placeholder,
    disabled: btnDisabled,
    "aria-label": placeholder,
    onChange: (e) => setValue(e.target.value),
    value,
    className: blink ? "blink" : "",
  }

  return (
    <SenderContainer>
      <Menu onMenuButtonClick={onMenuItemClick} />
      <TOCButton />
      <FormSender onSubmit={handleMessageSubmit}>
        <BlinkWrapper blinkColor={blinkColor}>
          {isInputExpanded && <TextareaInput {...inputProps} />}
          {!isInputExpanded &&
            (dateInput ? (
              <DateInput {...inputProps} />
            ) : (
              <TextInput {...inputProps} />
            ))}
          {!dateInput && (
            <ToggleExpand
              onClick={() => setInputExpanded(!inputExpanded)}
              title="Expand input"
              type="button"
            >
              {isInputExpanded ? <FaCompress /> : <FaExpand />}
            </ToggleExpand>
          )}
        </BlinkWrapper>
        <BtnSend type="submit" disabled={btnDisabled} aria-label="send message">
          <RiSendPlaneLine />
        </BtnSend>
      </FormSender>
    </SenderContainer>
  )
}

Sender.propTypes = {
  placeholder: PropTypes.string,
  inputDisabled: PropTypes.bool,
  isFetching: PropTypes.bool,
  blink: PropTypes.bool,
  blinkColor: PropTypes.string
}

const mapStateToProps = createStructuredSelector({
  inputDisabled: selectors.selectInputDisabled,
  blink: selectors.selectBlink,
  blinkColor: selectors.selectBlinkColor,
  dropdownInput: selectors.selectDropdownInput,
  dateInput: selectors.selectDateInput,
  isFetching: selectors.selectIsFetching,
  clearInput: selectors.selectClearInput,
})

const mapDispatchToProps = dispatch => ({
  newUserMessage: text => dispatch(newUserMessage({ text })),
})

export default connect(mapStateToProps, mapDispatchToProps)(Sender)

const SenderContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: var(--clr-grey-0-to-black, ${vars.grey1});
  padding: 10px;
  border-radius: 0 0 10px 10px;
  position: relative;

  @media screen and (max-width: ${FULLSCEEN_WIDTH_BREAKPOINT}px)  {
    border-radius: 0;
    flex-shrink: 0;
  }
`

const FormSender = styled.form`
  flex: 1;
  align-items: center;
  display: flex;
  justify-content: flex-start;

  /* Removes the clear button from date inputs */
input[type="date"]::-webkit-clear-button {
    display: none;
}

/* Removes the spin button */
input[type="date"]::-webkit-inner-spin-button {
    display: none;
}

/* Always display the drop down caret */
input[type="date"]::-webkit-calendar-picker-indicator {
    color: #2c3e50;
}

/* A few custom styles for date inputs */
input[type="date"] {
    appearance: none;
    -webkit-appearance: none;
    color: #95a5a6;
    font-size: 18px;
    border:1px solid #ecf0f1;
    padding:5px;
    display: inline-block !important;
    visibility: visible !important;
}

input[type="date"], focus {
    color: #95a5a6;
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
}
`
const BlinkWrapper = styled.div`
  width: 92%;
  height: 40px;
  padding: 0 10px;

  .blink {
    outline: transparent solid 3px;
    animation: ${props => blinkBuilder(get(props, 'blinkColor', 'blue'))} .8s step-end 0.01s infinite alternate;
  }
`
const Input = styled.input`
  width: 100%;
  background-color: var(--clr-white-to-text, ${props => props.disabled ? `#FBFBFB` : vars.white});
  opacity: ${props => props.disabled ? '0.75' : null};
  border: 0;
  border-radius: 5px;
  padding-left: 15px;
  padding-right: 25px;
  height: 40px;

  ${props => props.disabled && '::-webkit-input-placeholder { color: #DCDCDC; }'}

  ::placeholder {
        color: var(--clr-grey-4-to-white, #f9f9f9) !important;
  }
`

const Textarea = styled.textarea`
  height: 200px;
  width: 100%;
  background-color: var(--clr-white-to-text, ${props => props.disabled ? `#FBFBFB` : vars.white});
  resize: none;
  ${props => props.disabled && '::-webkit-input-placeholder { color: #DCDCDC; }'}
  border: 0;
  border-radius: 5px;
  padding-left: 15px;
  padding-right: 15px;
  margin-right: 10px;
`

const BtnSend = styled.button`
  background: var(--clr-grey-0-to-black, ${vars.grey1});
  border: 0;
  color: var(--clr-bot-main, ${props => props.theme.primaryColor});
  padding: 0;
  font-size: 20px;

  &:disabled {
    color: ${vars.grey2};
  }
`

const ToggleExpand = styled.button`
  position: absolute;
  right: 45px;
  top: 18px;
  color: var(--clr-bot-main, ${props => props.theme.primaryColor});
  background: none;
  border: none;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Sender/index.js